import { useCampaignCreationStore } from 'modules/campaign-creation/stores/useCampaignCreationStore';
import { CampaignAutomationPage } from 'pages/CampaignAutomationPage';

export const CampaignCreationAutomationStep: React.FC = () => {
  const state = useCampaignCreationStore((store) => store.state);

  return (
    <CampaignAutomationPage
      closingMethod={state?.setupAndSimulationFields?.closingMethod}
      atsJobId={state?.ATSJobDescriptionState?.selectedJob?.atsJobId}
      atsListId={state?.ATSImportState?.atsListId}
      questions={state?.questions || []}
      showLaunchButtons
    />
  );
};
